import { Directive, Output , HostListener, ElementRef, EventEmitter } from '@angular/core';
import { ExpertTrimOptions } from './expert-trim.component';

@Directive({
  selector: '[trimPlaceholderNullOnClick]'
})

export class TrimPlaceholderNull {
   constructor(private _elementRef : ElementRef , private expertTrimOption : ExpertTrimOptions) {
    }

    @Output()
    public trimPlaceholderNullOnClick = new EventEmitter();

 /* To capture all clicks on the host element of the document and 
 check if the click is inside or outside of the element*/
    @HostListener('document:click', ['$event','$event.target'])
    public onClick(event: MouseEvent, targetElement:HTMLElement) {
        if(!this._elementRef.nativeElement.contains(targetElement))
        {   
            this.expertTrimOption.expertTrimOptions="";
        }
    }



}



// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-trim/expert-trim-placeholder-null.ts